<template>
  <div class="flight-board">
    <div class="flight-board__bg flight-board__bg--left"></div>
    <div class="flight-board__bg flight-board__bg--right"></div>

    <div class="flight-board__shell">
      <header class="flight-board__header">
        <div>
          <p class="flight-board__eyebrow">Airport Transfer Dashboard</p>
          <h1 class="flight-board__title">航班接送信息展示</h1>
          <p class="flight-board__subtitle">
            左侧展示多班次送机安排，右侧展示多班次接机安排。
          </p>
        </div>

        <div class="flight-board__status-card">
          <span class="flight-board__status-label">今日保障任务</span>
          <strong class="flight-board__status-value">{{ totalFlights }} 个航班联动中</strong>
          <span class="flight-board__status-note">悬停卡片可暂停滚动，便于现场人员查看详情</span>
        </div>
      </header>

      <main class="flight-board__grid">
        <section class="flight-panel flight-panel--departure">
          <div class="flight-panel__top">
            <div>
              <span class="flight-panel__badge">送机信息</span>
              <h2 class="flight-panel__title">送机航班滚动看板</h2>
            </div>
            <div class="flight-chip flight-chip--departure">{{ departureFlights.length }} 班</div>
          </div>

          <div class="flight-panel__summary">
            <span class="flight-panel__summary-label">展示建议</span>
            <p>每张卡片保留起飞时间、登机口、车辆牌号和司机信息，按固定节奏循环向上滚动。</p>
          </div>

          <div class="flight-scroll flight-scroll--departure">
            <div class="flight-scroll__track">
              <article
                v-for="(flight, index) in departureLoop"
                :key="`departure-${flight.flightNo}-${index}`"
                class="flight-ticket"
              >
                <div class="flight-ticket__head">
                  <div>
                    <div class="flight-ticket__eyebrow">送机航班</div>
                    <h3 class="flight-ticket__title">{{ flight.flightNo }}</h3>
                  </div>
                  <div class="flight-ticket__tag">起飞 {{ flight.time }}</div>
                </div>

                <div class="flight-ticket__route">
                  <div>
                    <div class="flight-ticket__airport">{{ flight.from }}</div>
                    <div class="flight-ticket__terminal">{{ flight.fromTerminal }}</div>
                  </div>

                  <div class="flight-route">
                    <span>{{ flight.codeFrom }}</span>
                    <div class="flight-route__line"></div>
                    <span>{{ flight.codeTo }}</span>
                  </div>

                  <div class="flight-ticket__arrival">
                    <div class="flight-ticket__airport">{{ flight.to }}</div>
                    <div class="flight-ticket__terminal">{{ flight.toTerminal }}</div>
                  </div>
                </div>

                <div class="flight-ticket__grid">
                  <div class="flight-detail">
                    <span class="flight-detail__label">起飞时间</span>
                    <strong class="flight-detail__value">{{ flight.time }}</strong>
                  </div>
                  <div class="flight-detail">
                    <span class="flight-detail__label">登机口</span>
                    <strong class="flight-detail__value">{{ flight.gate }}</strong>
                  </div>
                  <div class="flight-detail">
                    <span class="flight-detail__label">车辆牌号</span>
                    <strong class="flight-detail__value">{{ flight.carNo }}</strong>
                  </div>
                  <div class="flight-detail">
                    <span class="flight-detail__label">司机信息</span>
                    <strong class="flight-detail__value">{{ flight.driver }}</strong>
                  </div>
                </div>

                <p class="flight-ticket__note">{{ flight.note }}</p>
              </article>
            </div>
          </div>
        </section>

        <section class="flight-panel flight-panel--arrival">
          <div class="flight-panel__top">
            <div>
              <span class="flight-panel__badge">接机信息</span>
              <h2 class="flight-panel__title">接机航班滚动看板</h2>
            </div>
            <div class="flight-chip flight-chip--arrival">{{ arrivalFlights.length }} 班</div>
          </div>

          <div class="flight-panel__summary">
            <span class="flight-panel__summary-label">展示建议</span>
            <p>重点展示到达时间、出口、车辆和司机，适合接机大厅、礼宾台或车队调度快速查看。</p>
          </div>

          <div class="flight-scroll flight-scroll--arrival">
            <div class="flight-scroll__track">
              <article
                v-for="(flight, index) in arrivalLoop"
                :key="`arrival-${flight.flightNo}-${index}`"
                class="flight-ticket"
              >
                <div class="flight-ticket__head">
                  <div>
                    <div class="flight-ticket__eyebrow">接机航班</div>
                    <h3 class="flight-ticket__title">{{ flight.flightNo }}</h3>
                  </div>
                  <div class="flight-ticket__tag">到达 {{ flight.time }}</div>
                </div>

                <div class="flight-ticket__route">
                  <div>
                    <div class="flight-ticket__airport">{{ flight.from }}</div>
                    <div class="flight-ticket__terminal">{{ flight.fromTerminal }}</div>
                  </div>

                  <div class="flight-route">
                    <span>{{ flight.codeFrom }}</span>
                    <div class="flight-route__line"></div>
                    <span>{{ flight.codeTo }}</span>
                  </div>

                  <div class="flight-ticket__arrival">
                    <div class="flight-ticket__airport">{{ flight.to }}</div>
                    <div class="flight-ticket__terminal">{{ flight.toTerminal }}</div>
                  </div>
                </div>

                <div class="flight-ticket__grid">
                  <div class="flight-detail">
                    <span class="flight-detail__label">到达时间</span>
                    <strong class="flight-detail__value">{{ flight.time }}</strong>
                  </div>
                  <div class="flight-detail">
                    <span class="flight-detail__label">到达出口</span>
                    <strong class="flight-detail__value">{{ flight.exit }}</strong>
                  </div>
                  <div class="flight-detail">
                    <span class="flight-detail__label">车辆牌号</span>
                    <strong class="flight-detail__value">{{ flight.carNo }}</strong>
                  </div>
                  <div class="flight-detail">
                    <span class="flight-detail__label">司机信息</span>
                    <strong class="flight-detail__value">{{ flight.driver }}</strong>
                  </div>
                </div>

                <p class="flight-ticket__note">{{ flight.note }}</p>
              </article>
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script setup>
const departureFlights = [
  {
    flightNo: "CZ3568",
    time: "14:35",
    from: "上海浦东",
    fromTerminal: "T2 航站楼",
    to: "深圳宝安",
    toTerminal: "T3 航站楼",
    codeFrom: "PVG",
    codeTo: "SZX",
    gate: "D12",
    carNo: "沪A·8926M",
    driver: "陈师傅 138-0013-8899",
    note: "贵宾携带两件托运行李，请司机在 VIP 上客点 B 区等候，并提前电话确认。",
  },
  {
    flightNo: "CA1831",
    time: "16:10",
    from: "上海虹桥",
    fromTerminal: "T1 航站楼",
    to: "北京首都",
    toTerminal: "T3 航站楼",
    codeFrom: "SHA",
    codeTo: "PEK",
    gate: "H08",
    carNo: "沪C·2R561",
    driver: "王师傅 137-7002-1688",
    note: "客户为团队出行，请司机预留后备箱空间，并在出发层 6 号门外待命。",
  },
  {
    flightNo: "MU2457",
    time: "19:05",
    from: "上海浦东",
    fromTerminal: "T1 航站楼",
    to: "成都天府",
    toTerminal: "T2 航站楼",
    codeFrom: "PVG",
    codeTo: "TFU",
    gate: "C19",
    carNo: "沪B·9M832",
    driver: "赵师傅 136-9918-5521",
    note: "旅客行动较慢，请司机协助从最近入口送达，并预留轮椅通道时间。",
  },
];

const arrivalFlights = [
  {
    flightNo: "MU5112",
    time: "18:20",
    from: "北京首都",
    fromTerminal: "T3 航站楼",
    to: "上海虹桥",
    toTerminal: "国内到达层",
    codeFrom: "PEK",
    codeTo: "SHA",
    exit: "3 号出口",
    carNo: "沪B·6K271",
    driver: "李师傅 139-1022-7716",
    note: "接机牌显示“商务接待”，旅客抵达后由司机协助搬运行李并引导上车。",
  },
  {
    flightNo: "HU7609",
    time: "20:05",
    from: "海口美兰",
    fromTerminal: "T2 航站楼",
    to: "上海浦东",
    toTerminal: "国际到达层",
    codeFrom: "HAK",
    codeTo: "PVG",
    exit: "8 号出口",
    carNo: "沪D·1F907",
    driver: "周师傅 135-8801-4473",
    note: "外宾旅客，请司机举双语接机牌，并与礼宾人员同步入境等待时间。",
  },
  {
    flightNo: "FM9446",
    time: "21:40",
    from: "广州白云",
    fromTerminal: "T1 航站楼",
    to: "上海虹桥",
    toTerminal: "国内到达层",
    codeFrom: "CAN",
    codeTo: "SHA",
    exit: "2 号出口",
    carNo: "沪A·7Q215",
    driver: "孙师傅 158-0048-6206",
    note: "客人落地后需直接前往酒店，请司机走快速接站路线，减少等待时间。",
  },
];

const departureLoop = [...departureFlights, ...departureFlights];
const arrivalLoop = [...arrivalFlights, ...arrivalFlights];
const totalFlights = departureFlights.length + arrivalFlights.length;
</script>

<style scoped>
.flight-board {
  --surface: rgba(255, 255, 255, 0.78);
  --text: #1c2430;
  --muted: #697586;
  --line: rgba(28, 36, 48, 0.08);
  --departure: #0f766e;
  --departure-soft: #daf4ee;
  --arrival: #c2410c;
  --arrival-soft: #ffedd9;
  --shadow: 0 24px 80px rgba(28, 36, 48, 0.12);
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding: 32px 20px 40px;
  background:
    radial-gradient(circle at top left, rgba(15, 118, 110, 0.18), transparent 30%),
    radial-gradient(circle at top right, rgba(194, 65, 12, 0.16), transparent 28%),
    linear-gradient(180deg, #f8f4ed 0%, #f2ede3 100%);
  color: var(--text);
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  box-sizing: border-box;
}

.flight-board *,
.flight-board *::before,
.flight-board *::after {
  box-sizing: inherit;
}

.flight-board__bg {
  position: absolute;
  border-radius: 999px;
  filter: blur(18px);
  opacity: 0.65;
}

.flight-board__bg--left {
  top: 110px;
  left: -80px;
  width: 260px;
  height: 260px;
  background: rgba(15, 118, 110, 0.14);
}

.flight-board__bg--right {
  right: -100px;
  bottom: 80px;
  width: 320px;
  height: 320px;
  background: rgba(194, 65, 12, 0.12);
}

.flight-board__shell {
  position: relative;
  z-index: 1;
  max-width: 1420px;
  margin: 0 auto;
}

.flight-board__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 24px;
}

.flight-board__eyebrow {
  margin: 0 0 10px;
  color: #7f6d53;
  font-size: 12px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.flight-board__title {
  margin: 0;
  font-size: 38px;
  line-height: 1.08;
}

.flight-board__subtitle {
  max-width: 720px;
  margin: 12px 0 0;
  color: var(--muted);
  font-size: 15px;
  line-height: 1.7;
}

.flight-board__status-card {
  min-width: 280px;
  padding: 18px 20px;
  border: 1px solid rgba(255, 255, 255, 0.62);
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(16px);
  box-shadow: var(--shadow);
}

.flight-board__status-label,
.flight-board__status-note {
  display: block;
}

.flight-board__status-label {
  margin-bottom: 8px;
  color: var(--muted);
  font-size: 12px;
}

.flight-board__status-value {
  display: block;
  font-size: 24px;
  line-height: 1.2;
}

.flight-board__status-note {
  margin-top: 10px;
  color: #7f6d53;
  font-size: 13px;
}

.flight-board__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px;
}

.flight-panel {
  position: relative;
  padding: 28px;
  border: 1px solid rgba(255, 255, 255, 0.62);
  border-radius: 30px;
  background: var(--surface);
  backdrop-filter: blur(14px);
  box-shadow: var(--shadow);
}

.flight-panel::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
}

.flight-panel--departure::after {
  box-shadow: inset 0 0 0 1px rgba(15, 118, 110, 0.08);
}

.flight-panel--arrival::after {
  box-shadow: inset 0 0 0 1px rgba(194, 65, 12, 0.08);
}

.flight-panel__top,
.flight-ticket__head,
.flight-ticket__route,
.flight-route {
  display: flex;
}

.flight-panel__top,
.flight-ticket__head,
.flight-ticket__route {
  align-items: center;
  justify-content: space-between;
}

.flight-panel__badge {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.flight-panel--departure .flight-panel__badge {
  background: var(--departure-soft);
  color: var(--departure);
}

.flight-panel--arrival .flight-panel__badge {
  background: var(--arrival-soft);
  color: var(--arrival);
}

.flight-panel__title {
  margin: 14px 0 0;
  font-size: 28px;
  line-height: 1.18;
}

.flight-chip {
  min-width: 96px;
  padding: 10px 14px;
  border-radius: 16px;
  text-align: center;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.flight-chip--departure {
  background: linear-gradient(135deg, #0f766e, #159b8f);
  color: #fff;
}

.flight-chip--arrival {
  background: linear-gradient(135deg, #c2410c, #ea6d2f);
  color: #fff;
}

.flight-panel__summary {
  margin-top: 22px;
  padding: 16px 18px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.72);
}

.flight-panel__summary-label {
  display: inline-block;
  margin-bottom: 8px;
  color: #7f6d53;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
}

.flight-panel__summary p {
  margin: 0;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.7;
}

.flight-scroll {
  position: relative;
  height: 760px;
  margin-top: 18px;
  overflow: hidden;
  mask-image: linear-gradient(to bottom, transparent 0, #000 6%, #000 94%, transparent 100%);
}

.flight-scroll__track {
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: flight-marquee 24s linear infinite;
}

.flight-scroll:hover .flight-scroll__track {
  animation-play-state: paused;
}

.flight-scroll--arrival .flight-scroll__track {
  animation-duration: 26s;
}

.flight-ticket {
  padding: 20px;
  border: 1px solid var(--line);
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.7);
}

.flight-ticket__eyebrow {
  color: var(--muted);
  font-size: 12px;
}

.flight-ticket__title {
  margin: 6px 0 0;
  font-size: 26px;
  line-height: 1.1;
}

.flight-ticket__tag {
  min-width: 108px;
  padding: 10px 12px;
  border-radius: 14px;
  text-align: center;
  font-size: 13px;
  font-weight: 800;
  background: #fff;
}

.flight-panel--departure .flight-ticket__tag {
  color: var(--departure);
}

.flight-panel--arrival .flight-ticket__tag {
  color: var(--arrival);
}

.flight-ticket__route {
  gap: 14px;
  margin-top: 18px;
}

.flight-ticket__airport {
  font-size: 18px;
  font-weight: 800;
}

.flight-ticket__terminal {
  margin-top: 4px;
  color: var(--muted);
  font-size: 12px;
}

.flight-ticket__arrival {
  text-align: right;
}

.flight-route {
  align-items: center;
  gap: 12px;
  min-width: 170px;
  color: #667085;
  font-size: 18px;
  font-weight: 800;
}

.flight-route__line {
  position: relative;
  flex: 1;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(102, 112, 133, 0.2), rgba(102, 112, 133, 0.7));
}

.flight-route__line::after {
  content: "";
  position: absolute;
  top: -3px;
  right: -1px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
}

.flight-ticket__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 18px;
}

.flight-detail {
  padding: 14px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.82);
}

.flight-detail__label {
  color: var(--muted);
  font-size: 12px;
}

.flight-detail__value {
  display: block;
  margin-top: 8px;
  font-size: 17px;
  line-height: 1.45;
}

.flight-ticket__note {
  margin: 16px 0 0;
  color: #4b5565;
  font-size: 13px;
  line-height: 1.7;
}

@keyframes flight-marquee {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(calc(-50% - 8px));
  }
}

@media (max-width: 1100px) {
  .flight-board__header,
  .flight-ticket__head,
  .flight-ticket__route {
    align-items: flex-start;
    flex-direction: column;
  }

  .flight-board__grid {
    grid-template-columns: 1fr;
  }

  .flight-route {
    width: 100%;
  }

  .flight-scroll {
    height: 620px;
  }
}

@media (max-width: 640px) {
  .flight-board {
    padding: 20px 14px 28px;
  }

  .flight-panel {
    padding: 18px;
    border-radius: 24px;
  }

  .flight-board__title {
    font-size: 28px;
  }

  .flight-panel__title,
  .flight-ticket__title {
    font-size: 22px;
  }

  .flight-panel__summary,
  .flight-ticket,
  .flight-detail {
    padding: 16px;
  }

  .flight-ticket__grid {
    grid-template-columns: 1fr;
  }

  .flight-scroll {
    height: 560px;
    mask-image: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .flight-scroll {
    height: auto;
    overflow: auto;
    mask-image: none;
  }

  .flight-scroll__track {
    animation: none;
  }
}
</style>
